export default {
    name: 'CustomLoader',
    template: `
    <div class="loader">
        <div class="loader__icon" />
    </div>
    `
}